import { Permissions } from "@/lib/permissions";
import { MenuType } from "@/@types/common";

const menuRoutes: MenuType[] = [
	{ path: "/operations", name: "Home", ttoken: "menu.home", icon: "home" },
	{ path: "/object-analysis", name: "object-analysis", ttoken: "menu.object_analysis", icon: "view_quilt" },
	//{ path: "/operations/vectorizing", name: "vectorizing", ttoken: "menu.vectorizing", icon: "polyline" },
	// { path: "/map", name: "map", ttoken: "menu.map", icon: "map" },
	// { path: "/fotodokumentacija-objekata", name: "processing", ttoken: "menu.processing", icon: "picture_in_picture" },
	{
		path: "/users",
		name: "users",
		ttoken: "menu.users",
		icon: "group",
		needPermission: [Permissions.Administration]
	},
	{
		path: "/tasks",
		name: "tasks",
		ttoken: "menu.tasks",
		icon: "assignment",
		needPermission: [Permissions.Administration]
	},
	{
		path: "/utility-liabilities",
		name: "zapisnici",
		ttoken: "menu.zapisnici",
		icon: "electrical_services",
		needPermission: [Permissions.Administration]
	},
	{
		path: "/radni-sastanci",
		name: "sastanci",
		ttoken: "menu.sastanci",
		icon: "groups",
		needPermission: [Permissions.Administration]
	},
	{
		path: "/projects",
		name: "projekti",
		ttoken: "menu.projects",
		icon: "home_work",
		needPermission: [Permissions.Administration]
	},
	{
		path: "/quality-control",
		name: "quality control",
		ttoken: "menu.qc",
		icon: "rule",
		needPermission: [Permissions.Administration]
	},
];

export default menuRoutes;
